/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const diffusionSchema = z.object({
      "id": z.number().int().describe("ID de la diffusion").optional(),
  "active": z.boolean().describe("Indique si la diffusion est active ou non").optional(),
  "code_produit": z.string().describe("Code du produit de diffusion").optional(),
  "status": z.enum(["en_attente", "en_attente_retry", "en_cours", "publie", "erreur", "depublie"]).describe("Statut de la diffusion").optional(),
  "nb_photos_envoyees": z.number().int().describe("Nombre de photos envoyées au diffuseur").optional(),
  "date_diffusion": z.string().describe("Date & heure de la dernière mise à jour de la diffusion (ISO local, heure de Paris, sans fuseau)").optional(),
  "message_erreur": z.string().describe("Dernier message d'erreur remonté par le diffuseur").optional(),
  "url_annonce": z.string().describe("URL de l'annonce en ligne chez le diffuseur").optional()
      })